class CollectionParentBlock extends HTMLElement {
  constructor() {
    super();
  }

  getFacetsWrapper() {
    return window.innerWidth >= 750 ? '#FacetsWrapperDesktop' : '#FacetFiltersFormMobile';
  }

  // Public handler called by the delegated document click listener.
  // `event` is the original click event; `this` is the block instance.
  handleClick(event) {
    const button = event.target.closest('button[data-target]');
    if (!button) return;

    event.preventDefault();
    const isActive = button.hasAttribute('data-active');
    if (isActive) {
      button.removeAttribute('data-active');
    } else {
      button.setAttribute('data-active', 'true');
    }

    // Get the data-target attribute value from the clicked button
    const targetId = button.getAttribute('data-target');
    const checked = !isActive;

    if (targetId.startsWith('esp-btu-')) {
      this.handleEspBtu(targetId, event, checked);
    } else if (targetId === 'esp-commercial') {
      this.handleEspCommercial(targetId, event, checked);
    } else if (targetId === 'esp-other') {
      this.handleEspOther(targetId, event, checked);
    } else if (targetId === 'esp-all-states') {
      this.handleEspAllStates(targetId, event, checked);
    } else {
      const facetsWrapper = this.getFacetsWrapper();

      /*
      ! P80: This logic is added specifically for:
      ! Matched > System Tonnage - min 1
      ! Evaporator Coils Dx > System Tonnage - min 1.5
      ! Compressors > System Tonnage - min 1.5
      */
      if (targetId === 'Filter-filter.p.m.product.capacity-1') {
        const additionalValues = ['.5', '.75'];

        const parentEl = this.querySelector('.collection-parent__filter');
        const hasOne = parentEl?.querySelector('[data-value-label="1"]');
        const hasOnePointFive = parentEl?.querySelector('[data-value-label="1-5"]');

        if (!hasOne && hasOnePointFive) {
          // If "1" is false AND "1-5" is true -> include 1 and 1.5
          additionalValues.push('1');
          additionalValues.push('1.5');
        } else if (hasOne) {
          // Else if "1" is true -> include 1
          additionalValues.push('1');
        }

        const lastValue = additionalValues[additionalValues.length - 1];

        // First, check all checkboxes except the last without triggering events
        additionalValues.forEach((value) => {
          if (value === lastValue) return;

          const additionalCheckboxes = document.querySelectorAll(
            `${facetsWrapper} input[name="filter.p.m.product.capacity"][value="${value}"]`
          );

          additionalCheckboxes.forEach((checkbox) => {
            checkbox.checked = checked;
          });
        });

        // Then trigger click only on the last one (click will check it)
        const lastCheckbox = document.querySelector(
          `${facetsWrapper} input[name="filter.p.m.product.capacity"][value="${lastValue}"]`
        );
        if (lastCheckbox) {
          lastCheckbox.click();
        }
      } else {
        const checkbox = document.querySelector(`${facetsWrapper} input[type="checkbox"][id="${targetId}"]`);
        // If the checkbox is found, trigger its click event
        if (checkbox) checkbox.click();
      }
    }
  }

  // Generalized helper
  toggleCheckboxesByCondition(event, conditionFn, checked = true) {
    const parentEl = event.target.closest('collection-parent-block');
    if (!parentEl) return;
    const name = parentEl.dataset.name;
    const facetsWrapper = this.getFacetsWrapper();
    const container = document.querySelector(`${facetsWrapper} [data-name="${name}"]`);
    if (!container) return;

    const checkboxes = container.querySelectorAll('input[type="checkbox"]');
    const relevantCheckboxes = [];

    checkboxes.forEach((checkbox) => {
      if (conditionFn(checkbox)) {
        relevantCheckboxes.push(checkbox);
      }
    });

    // Trigger click on the last relevant checkbox (for filter update)
    if (relevantCheckboxes.length > 0) {
      const lastCheckboxToClick = relevantCheckboxes[relevantCheckboxes.length - 1];

      relevantCheckboxes.forEach((cb) => {
        if (cb === lastCheckboxToClick) {
          // For the checkbox that will be clicked, its state *before* the click
          // must be the opposite of the desired final 'checked' state,
          // because .click() will toggle it.
          cb.checked = !checked;
        } else {
          // For all other relevant checkboxes, set them directly to the desired state.
          cb.checked = checked;
        }
      });

      // Now click the last one. Its state will toggle to the desired 'checked' state,
      // and it will trigger the filter update. All other relevant checkboxes
      // are already in the desired 'checked' state.
      lastCheckboxToClick.click();
    }
  }

  handleEspCommercial(targetId, event, checked = true) {
    this.toggleCheckboxesByCondition(
      event,
      (checkbox) => {
        const rawValue = checkbox.value;
        let numToTest;

        if (typeof rawValue === 'string') {
          const hyphenIndex = rawValue.indexOf('-');
          if (hyphenIndex !== -1) {
            // Hyphen exists, parse the part before it
            numToTest = parseInt(rawValue.substring(0, hyphenIndex), 10);
          } else {
            // No hyphen, parse the whole string
            numToTest = parseInt(rawValue, 10);
          }
        } else {
          // Fallback for non-string values (though checkbox.value is typically string)
          numToTest = parseInt(rawValue, 10);
        }
        return !isNaN(numToTest) && numToTest >= 6;
      },
      checked
    );
  }

  handleEspOther(targetId, event, checked = true) {
    const excludedValues = ['upflow', 'horizontal', 'downflow'];
    this.toggleCheckboxesByCondition(
      event,
      (checkbox) => !excludedValues.includes(checkbox.value.toLowerCase()),
      checked
    );
  }

  handleEspAllStates(targetId, event, checked = true) {
    const excludedValues = ['North Only', 'All regions', 'no-restriction']; // ex. 'north only'
    // Force uncheck all Region Approved options
    checked = false;

    this.toggleCheckboxesByCondition(
      event,
      (checkbox) => !excludedValues.includes(checkbox.value.toLowerCase()),
      checked
    );
  }

  handleEspBtu(targetId, event, checked = true) {
    const parentEl = event.target.closest('collection-parent-block');
    if (!parentEl) return;

    const name = parentEl.dataset.name;
    const facetsWrapper = this.getFacetsWrapper();
    const btuContainer =
      window.innerWidth >= 750
        ? document.querySelector(`${facetsWrapper} > [data-name="${name}"]`)
        : document.querySelector(
            `${facetsWrapper} .mobile-facets__details[data-name="${name}"]:not(.mobile-facets__icon-buttons)`
          );

    if (!btuContainer) return;

    const clickedBtuValueStr = targetId.replace('esp-btu-', '');
    const clickedBtuValue = parseInt(clickedBtuValueStr, 10); // e.g. 30000
    if (isNaN(clickedBtuValue)) return;

    // 1. Source of Truth: Your Threshold Array
    const btuThresholds = [30000, 40000, 60000, 80000, 100000, 120000].sort((a, b) => a - b);

    // 2. Identify Position in Array
    const currentIndex = btuThresholds.indexOf(clickedBtuValue);
    const isFirstThreshold = currentIndex === 0; // Is this 30,000?
    const isLastThreshold = currentIndex === btuThresholds.length - 1; // Is this 120,000?

    // 3. Determine the "Ceiling" (Next Threshold)
    // If I clicked 30k, ceiling is 40k. If I clicked 40k, ceiling is 60k.
    let nextBtuThreshold = Infinity;

    if (currentIndex !== -1 && currentIndex < btuThresholds.length - 1) {
      nextBtuThreshold = btuThresholds[currentIndex + 1];
    } else if (currentIndex === -1) {
      // Fallback logic if clicked value isn't in the list
      for (const threshold of btuThresholds) {
        if (threshold > clickedBtuValue) {
          nextBtuThreshold = threshold;
          break;
        }
      }
    }

    const checkboxes = btuContainer.querySelectorAll('input[type="checkbox"]:not(:disabled)');
    const relevantCheckboxes = [];

    checkboxes.forEach((checkbox) => {
      const rawValue = checkbox.value;
      if (!rawValue || !rawValue.toUpperCase().includes('BTU')) return;

      let fromNumber = NaN;

      // --- REGEX PARSING (Updated for robustness) ---
      // 1. New "Tight" Format: "UNDER 12000btu", "13600btu+", "42000btu"
      const tightFormatRegex = /(?:UNDER\s*)?(\d+)\s*btu/i;
      let match = rawValue.match(tightFormatRegex);

      if (match && match[1]) {
        fromNumber = parseInt(match[1], 10);
      } else {
        // 2. Existing Format: "40k - 59k"
        const kRangeRegex = /(\d+)k\s*-\s*[\w\d]+k\s*BTU's/i;
        match = rawValue.match(kRangeRegex);
        if (match && match[1]) {
          fromNumber = parseInt(match[1], 10) * 1000;
        } else {
          // 3. Existing Format: "30,000" (comma)
          const singleWithCommaRegex = /([\d,]+)\s*BTU's/i;
          match = rawValue.match(singleWithCommaRegex);
          if (match && match[1]) {
            fromNumber = parseInt(match[1].replace(/,/g, ''), 10);
          } else {
            // 4. Fallbacks
            const originalRangeRegex = /(\d+)\s*TO\s*(\d+)/i;
            match = rawValue.match(originalRangeRegex);
            if (match && match[1]) {
              fromNumber = parseInt(match[1], 10);
            } else {
              const originalSingleBtuRegex = /(\d+)\s*BTU/i;
              match = rawValue.match(originalSingleBtuRegex);
              if (match && match[1]) {
                fromNumber = parseInt(match[1], 10);
              }
            }
          }
        }
      }

      if (isNaN(fromNumber)) return;

      // --- DYNAMIC BUCKET LOGIC ---
      let shouldCheck = false;

      if (isLastThreshold) {
        // Scenario: 120,000 button clicked
        // Check anything equal to or greater than 120k
        shouldCheck = fromNumber >= clickedBtuValue;
      } else if (isFirstThreshold) {
        // Scenario: 30,000 button clicked
        // Check anything LESS than the next tier (40,000)
        // This automatically includes: 12k, 18k, 30k, 36k
        shouldCheck = fromNumber < nextBtuThreshold;
      } else {
        // Scenario: Middle buttons (40k, 60k, etc.)
        // Check range: [Current, Next)
        // e.g. 40k button checks: 40k, 42k, 50k, 55k (stops before 60k)
        shouldCheck = fromNumber >= clickedBtuValue && fromNumber < nextBtuThreshold;
      }

      if (shouldCheck) {
        relevantCheckboxes.push(checkbox);
      }
    });

    if (relevantCheckboxes.length > 0) {
      const lastCheckboxToClick = relevantCheckboxes[relevantCheckboxes.length - 1];

      relevantCheckboxes.forEach((cb) => {
        if (cb === lastCheckboxToClick) {
          // Set to opposite so .click() toggles it to the desired state
          cb.checked = !checked;
        } else {
          cb.checked = checked;
        }
      });

      lastCheckboxToClick.click();
    }
  }
}

// ── Event delegation ──────────────────────────────────────────────────────
// A single document-level listener handles clicks on any
// <collection-parent-block> button.  It survives every innerHTML
// replacement (FacetFiltersForm.renderFilters, etc.) and never needs
// manual re-initialisation.
//
// This replaces the per-button listener loop that was previously in
// connectedCallback(), which failed after AJAX re-injection because the
// constructor runs before children are available when the element is
// created by the HTML parser.

document.addEventListener(
  'click',
  function (event) {
    const block = event.target.closest('collection-parent-block');
    if (block && typeof block.handleClick === 'function') {
      block.handleClick(event);
    }
  },
  false
);

// Define the custom element
customElements.define('collection-parent-block', CollectionParentBlock);
